let playPrimary = "#ce2b91";
let playSecondary = "#ebc0da";
let postingPrimary = "#00C6D7";
let postingSecondary = "#6AF4FF";
export {
    playPrimary, 
    playSecondary,
    postingPrimary,
    postingSecondary
}